$(document).ready(function () {
  setVboxVars();
});

$(window).resize(function () {
  if (this.resizeTO) clearTimeout(this.resizeTO);
  this.resizeTO = setTimeout(function () {
    $(this).trigger("resizeEnd");
  }, 250);
});

$(window).bind("resizeEnd", function () {
  setVboxVars();
});

function setVboxVars() {
  var tcwVbox1Height = $(".tcw-bp-vbox-1-relative video").height();
  var tcwVbox2Height = $(".tcw-bp-vbox-2-relative responsive-image").height();
  var tcwVbox3Height = $(".tcw-bp-vbox-1-static responsive-image").height();

  $(":root").css("--tcw-bp-vbox-1-height", tcwVbox1Height + "px");
  $(":root").css("--tcw-bp-vbox-2-height", tcwVbox2Height + "px");
  $(":root").css("--tcw-bp-vbox-static-1-height", tcwVbox3Height + "px");
}

$(".tcw-bp-pick").on("click", function () {
  $(".tcw-bp-pick").removeClass("active");
  $(this).addClass("active");
});

// About Page

document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".bin-tab-button");
  const contents = document.querySelectorAll(".bin-tab-content");
  const container = document.querySelector(".bin-container");

  buttons.forEach((button) => {
    button.addEventListener("mouseover", () => {
      const tabId = button.getAttribute("data-tab");

      contents.forEach((content) => {
        if (content.id === tabId) {
          content.classList.add("bin-active");
        } else {
          content.classList.remove("bin-active");
        }
      });

      container.classList.add("bin-show-right");
    });
  });

  container.addEventListener("mouseleave", () => {
    container.classList.remove("bin-show-right");
  });
});

// How To Use Page

function openTab(event, tabName) {
  var i, tabcontent, tabbuttons;
  tabcontent = document.getElementsByClassName("htu-tab-content");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tabbuttons = document.getElementsByClassName("htu-tab-button");
  for (i = 0; i < tabbuttons.length; i++) {
    tabbuttons[i].className = tabbuttons[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.display = "block";
  event.currentTarget.className += " active";
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelector(".htu-tab-button").click();
});


/* Slider on hp hero */

(() => {
  const wrap = document.querySelector('.tcw-bp-box-images');
  if (!wrap) return;
  const slides = [...wrap.querySelectorAll('.tcw-bp-box-images-slide')];
  if (slides.length < 2) { slides[0]?.classList.add('is-active'); return; }

  let i = 0, t;
  const set = n => slides.forEach((s,k)=>s.classList.toggle('is-active', k===n));
  const next = () => { i = (i+1) % slides.length; set(i); };
  const play = () => { if (!t) t = setInterval(next, 2500); };
  const pause = () => { clearInterval(t); t = null; };

  set(i); play();              // init
  wrap.addEventListener('mouseenter', pause);
  wrap.addEventListener('mouseleave', play);
  document.addEventListener('visibilitychange', () => document.hidden ? pause() : play());
})();



// document.addEventListener('DOMContentLoaded', function() {
//   const restrictedProductId = 7431820574934; 
//   const checkoutBtn = document.querySelector('[name="checkout"]');
//   if (!checkoutBtn) return;

//   function checkCart() {
//     fetch('/cart.js')
//       .then(res => res.json())
//       .then(cart => {
//         const items = cart.items;
//         const onlyRestricted =
//           items.length === 1 && items[0].product_id === restrictedProductId;

//         if (onlyRestricted) {
//           checkoutBtn.disabled = true;
//           checkoutBtn.classList.add('disabled');
//           checkoutBtn.textContent = 'Unavailable for Checkout';
//         } else {
//           checkoutBtn.disabled = false;
//           checkoutBtn.classList.remove('disabled');
//           checkoutBtn.textContent = 'Checkout';
//         }
//       })
//       .catch(err => console.error('Cart check failed:', err));
//   }


//   checkCart();

  
//   document.addEventListener('cart:updated', checkCart);

  
//   const observer = new MutationObserver(() => checkCart());
//   observer.observe(document.body, { childList: true, subtree: true });
// });
